<template>
  <fragment>
    <span class="prompt">{{ command.prompt }}</span>
    <span class="historyText" :class="[command.error ? 'error' : '']">{{
      command.text || command.data
    }}</span>
  </fragment>
</template>

<script>
export default {
  name: 'singlePrint',
  props: ['command']
};
</script>

<style scoped>
.historyText {
  white-space: pre-line;
  padding-left: 10px;
  position: relative;
  top: -1px;
  max-width: 90%;
  word-break: break-word;
}

.prompt {
  color: purple;
}

.error {
  color: red;
}
</style>
